<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
// import AppHeader from '@/components/Header';

export default {
  name: 'App'
}
</script>

<style>
#app {
  margin-top: 60px
}
</style>



// WEBPACK FOOTER //
// src/App.vue